import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslocoModule } from '@jsverse/transloco';
import { FeatureFlagComponent } from './feature-flag.component';

const routes: Routes = [
  {
    path: '',
    component: FeatureFlagComponent
  }
];

@NgModule({
  declarations: [FeatureFlagComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    TranslocoModule,
    RouterModule.forChild(routes)
  ]
})
export class FeatureFlagModule { }
